export const portfolioFormDefaults = {
  name: "",
  imageUrl: null,
  blurredImage: true,
  area: { path: "/", name: "" },
};
